import {
  FIXED_INDENTS,
  LabelFonts,
  TextBoxTypes,
  type CardContentTypeT,
  type SpecialRowContainerBackgroundT,
} from '@setplex/arcana'
import type { ViewRow } from '../model'

export const getCategoryId = (params: URLSearchParams): number => {
  const categoryId = params.get('categoryId') ?? 0

  return Number(categoryId)
}

export const getRowBackgroundStyle = (row?: ViewRow) => {
  const background = row?.appearance.style.background

  const rowBackground: Record<string, SpecialRowContainerBackgroundT> = {
    GRADIENT: 'SimpleGradient',
    IMAGE: 'SimpleFullWitdhImage',
    COLOR: 'none',
    UNSET: 'none',
  }

  return background?.type ? rowBackground[background.type] : 'none'
}

export const getRowBackgroundGradient = (row?: ViewRow) => {
  const background = row?.appearance.style.background

  if (background?.type === 'GRADIENT') {
    const config = background.configuration
    const colors = config.list.map(
      (colorConfig) => `${colorConfig.color} ${colorConfig.percentage}%`
    )
    return `linear-gradient(${config.angle}deg, ${colors.join(', ')})`
  }
}

export const getRowPosterImage = (row?: ViewRow) => {
  const background = row?.appearance.style.background
  if (background?.type === 'IMAGE') return background.imageUrl
}

export const getRowContentType = (row?: ViewRow): CardContentTypeT => {
  switch (row?.appearance.contentType) {
    case 'VOD':
    case 'TV_SHOW':
    case 'LIVE_EVENT':
    case 'MIXED':
    case 'PARTNER_PRODUCT':
    case 'VOD_BUNDLE':
    case 'TV_BUNDLE':
    case 'TV_SHOW_BUNDLE':
      return 'VODS_ADAPTIVE'
    case 'TV_CHANNEL':
      return 'CHANNELS_ADAPTIVE'
    default:
      return 'VODS_ADAPTIVE'
  }
}

export const getCardFonts = (size: 'S' | 'M' | 'L') => {
  const fontTitleConfig = {
    S: TextBoxTypes.Footnote5,
    M: TextBoxTypes.Footnote5,
    L: TextBoxTypes.Footnote5,
  }

  const fontLabelConfig = {
    S: LabelFonts.Body4,
    M: LabelFonts.Body4,
    L: LabelFonts.Body4,
  }

  return {
    titleFont: fontTitleConfig[size],
    labelFont: fontLabelConfig[size],
  }
}

export const getCardTitleMaxLines = (orientation: 'HORIZONTAL' | 'VERTICAL') =>
  orientation === 'VERTICAL' ? 2 : 1

export const getCardContentPadding = (size: 'S' | 'M' | 'L') => {
  const contentPaddingConfig = {
    S: FIXED_INDENTS.INDENT_40,
    M: FIXED_INDENTS.INDENT_50,
    L: FIXED_INDENTS.INDENT_60,
  }

  return contentPaddingConfig[size]
}

export const getCWCardPadding = (size: 'S' | 'M' | 'L') => {
  const paddingConfig = {
    S: FIXED_INDENTS.INDENT_20,
    M: FIXED_INDENTS.INDENT_25,
    L: FIXED_INDENTS.INDENT_30,
  }

  return paddingConfig[size]
}

export const getBundleCardConfig = (size: 'S' | 'M' | 'L') => {
  const fontTitleConfig = {
    S: TextBoxTypes.Footnote4,
    M: TextBoxTypes.Footnote3,
    L: TextBoxTypes.Footnote2,
  }

  const fontSubTitleConfig = {
    S: TextBoxTypes.Caption4,
    M: TextBoxTypes.Caption3,
    L: TextBoxTypes.Caption2,
  }

  const verticalGapConfig = {
    S: FIXED_INDENTS.INDENT_0,
    M: FIXED_INDENTS.INDENT_10,
    L: FIXED_INDENTS.INDENT_10,
  }

  return {
    titleFont: fontTitleConfig[size],
    subTitleFont: fontSubTitleConfig[size],
    verticalGap: verticalGapConfig[size],
  }
}
